<template>
  <v-container fluid>
      <router-view/>
  </v-container>
</template>

<script>
import {
  Capacitor,
  Plugins,
  
} from "@capacitor/core";

const { PushNotifications } = Plugins;
export default {
  name: 'Alerts',
  data () {
    return {
    }
  },
  methods: {
    clearNotifications()
    {
      var ua = navigator.userAgent.toLowerCase();
      let device = Capacitor.getPlatform();

      if(Capacitor.getPlatform() != 'ios' && Capacitor.getPlatform != 'android') return;

      PushNotifications.removeAllDeliveredNotifications();
    }
  },
  mounted() {
    this.clearNotifications();
  }
  
}
</script>

<style>

</style>